import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';

interface MenuInterface {
  name: string;
  link?: string | any[];
  type: 'All' | 'Danger';
  exact: boolean;
  icon: string;
  subMenuList?: MenuInterface[];
  disabled?: boolean;
}

const menuList: MenuInterface[] = [
  {
    name: 'Dashboard',
    link: ['/', 'tax-area-office'],
    type: 'All',
    exact: true,
    icon: 'assets/svgs/menu/dashboard.svg',
  },
  {
    name: 'Invoice Report',
    link: ['/', 'tax-area-office', 'invoice-reports'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/file-text.svg',
  },
  {
    name: 'Collection Report',
    link: ['/', 'tax-area-office', 'collection-reports'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/hard-drive.svg',
  },
  {
    name: 'Taxpayer Report',
    link: ['/', 'tax-area-office', 'taxpayer-reports'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/report.svg',
  },
  {
    name: 'Area Tax Offices Management',
    link: ['/', 'tax-area-office', 'office-management'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/report.svg',
    // disabled: true,
  },
  {
    name: 'Tax Intelligence Management',
    subMenuList: [
      {
        name: 'Reporting & Intelligence',
        link: ['/', 'tax-area-office', 'reporting-intelligence'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
      },
      {
        name: 'Tax Compliance Report',
        link: ['/', 'tax-area-office', 'tax-compliance-report'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
      },
    ],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/report.svg',
  },
  {
    name: 'Tax Enforcement Management',
    subMenuList: [
      {
        name: 'Enforcement Tracking',
        // link: ['/', 'tax-area-office', 'enforcement-tracking'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
        subMenuList: [
          {
            name: 'Legacy',
            link: ['/', 'tax-area-office', 'enforcement-tracking-legacy'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
          {
            name: 'Current',
            link: ['/', 'tax-area-office', 'enforcement-tracking-current'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
        ],
      },
      {
        name: 'Demand Notice Report',
        // link: ['/', 'tax-area-office', 'demand-notice-report'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
        subMenuList: [
          {
            name: 'Legacy',
            link: ['/', 'tax-area-office', 'demand-notice-report-legacy'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
            // disabled: true,
          },
          {
            name: 'Current',
            link: ['/', 'tax-area-office', 'demand-notice-report-current'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
        ],
      },
      {
        name: 'Consolidated Demand Notice Report',
        link: ['/', 'tax-area-office', 'consolidated-demand-notice-report'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
      },
      {
        name: 'Discrepancy Report',
        // link: ['/', 'tax-area-office', 'discrepancy-report'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
        subMenuList: [
          {
            name: 'Legacy',
            link: ['/', 'tax-area-office', 'discrepancy-report-legacy'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
          {
            name: 'Current',
            link: ['/', 'tax-area-office', 'discrepancy-report-current'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
        ],
      },
      {
        name: 'Appeal Management',
        // link: ['/', 'tax-area-office', 'appeal-management'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
        subMenuList: [
          {
            name: 'Legacy',
            link: ['/', 'tax-area-office', 'appeal-management-legacy'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
          {
            name: 'Current',
            link: ['/', 'tax-area-office', 'appeal-management-current'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
        ],
      },
      {
        name: 'Penalty Report',
        // link: ['/', 'tax-area-office', 'penalty-report'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
        subMenuList: [
          {
            name: 'Legacy',
            link: ['/', 'tax-area-office', 'penalty-report-legacy'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
          {
            name: 'Current',
            link: ['/', 'tax-area-office', 'penalty-report-current'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
        ],
      },
      {
        name: 'Schedule & Notification',
        // link: ['/', 'tax-area-office', 'schedule-notification'],
        type: 'All',
        exact: false,
        icon: 'assets/svgs/menu/report.svg',
        subMenuList: [
          // {
          //   name: 'Legacy',
          //   link: ['/', 'tax-area-office', 'schedule-notification-legacy'],
          //   type: 'All',
          //   exact: false,
          //   icon: 'assets/svgs/menu/report.svg',
          // },
          {
            name: 'Current',
            link: ['/', 'tax-area-office', 'schedule-notification-current'],
            type: 'All',
            exact: false,
            icon: 'assets/svgs/menu/report.svg',
          },
        ],
      },
    ],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/report.svg',
  },
];

const menuList2 = [
  {
    name: 'Settings',
    link: `/mda/settings`,
    type: 'All',
    exact: false,
    icon: 'assets/svgs/settings.svg',
  },
  {
    name: 'Log Out',
    link: '/',
    type: 'Danger',
    exact: true,
    icon: 'assets/svgs/menu/log-out.svg',
  },
];

@Component({
  selector: 'app-tao-sidemenu',
  standalone: true,
  imports: [
    SvgIconComponent,
    NzToolTipModule,
    RouterModule,
    NgScrollbarModule,
    CommonModule,
    NzMenuModule,
  ],
  templateUrl: './tao-sidemenu.component.html',
  styleUrl: './tao-sidemenu.component.css',
})
export class TaoSidemenuComponent {
  @Input({ required: true }) isCollapsed = false;

  menuList = signal(menuList);
  menuList2 = signal(menuList2);
}
